export const COOKIESPREFIX = 'BOCPROFILE'
export const server_ip = ''
export const WEBSITE = 'https://exploreskt.com'
// 'http://54.255.39.5/'
//https://skttest.shadowdesk.co